import { render } from "./LModal.vue?vue&type=template&id=194d341c"
import script from "./LModal.vue?vue&type=script&lang=js"
export * from "./LModal.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__